export default "__VITE_ASSET__DXtu8_H7__"